module.exports = __webpack_public_path__ + "img/core-logo-no-text.c3077148.svg";